<template>
  <article class="vehicle-card panel">
    <div v-if="vehicle.photos?.length" class="vehicle-card-photos">
      <img
        v-for="photo in vehicle.photos.slice(0, 3)"
        :key="photo.id"
        :src="photo.thumb_url || photo.url"
        :alt="vehicle.make"
        class="vehicle-card-photo"
      />
    </div>

    <div class="vehicle-card-body">
      <h3 class="vehicle-card-title">{{ vehicle.make }}</h3>
      <p v-if="vehicle.equipment" class="vehicle-card-equipment">{{ vehicle.equipment }}</p>
      <div v-if="showActions" class="vehicle-card-actions">
        <slot name="actions" />
      </div>
    </div>
  </article>
</template>

<script setup>
defineProps({
  vehicle: {
    type: Object,
    required: true,
  },
  showActions: {
    type: Boolean,
    default: false,
  },
})
</script>

<style scoped>
.vehicle-card {
  display: flex;
  gap: 1rem;
  padding: 1rem;
}

.vehicle-card-photos {
  display: flex;
  gap: 0.375rem;
  flex-shrink: 0;
}

.vehicle-card-photo {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 0.5rem;
}

.vehicle-card-body {
  flex: 1;
  min-width: 0;
}

.vehicle-card-title {
  margin: 0 0 0.25rem;
  font-size: 1rem;
}

.vehicle-card-equipment {
  margin: 0;
  color: #64748b;
  font-size: 0.875rem;
  white-space: pre-wrap;
}

.vehicle-card-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.75rem;
  flex-wrap: wrap;
}
</style>
